export function ajaxSuccess(id) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'ajaxSuccess',
    'eventCategory': 'AJAX',
    'idHTML': id
  });
}

export function ajaxEvent(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': event
  });
}